export default __webpack_public_path__ + "static/media/march.f497a333.png";